/**
 * Monte header transparente
 *
 * En el home, el header empieza transparente sobre el hero. Cuando el usuario
 * hace scroll mas alla del umbral, agrega la clase 'header-wrapper--scrolled'
 * para que el CSS pinte el header solido con fondo blanco.
 */

(function () {
  const wrapper = document.querySelector('.header-wrapper');
  if (!wrapper) return;

  // Templates donde el header siempre debe ser solido (sin transparencia inicial).
  const SOLID_TEMPLATES = ['template-product', 'template-page', 'template-cart', 'template-404', 'template-search'];
  const isSolidAlways = SOLID_TEMPLATES.some((t) => document.body.classList.contains(t));

  let ticking = false;
  let isHovering = false;

  // Threshold = altura de la barra de anuncios (para que se vuelva solido
  // exactamente cuando la barra termina de pasar y la parte superior del
  // navegador toca el header).
  const announcement = document.querySelector('.announcement-bar, [class*="announcement-bar"]');
  const getThreshold = () => (announcement ? announcement.offsetHeight : 1);

  const isScrolled = () => window.scrollY >= getThreshold();

  const apply = () => {
    const scrolled = isScrolled();
    // Fondo solido: cuando hay scroll real, hover, o si la pagina lo exige siempre.
    wrapper.classList.toggle('header-wrapper--solid', scrolled || isHovering || isSolidAlways);
    // Position fixed solo cuando hay scroll real (NO en hover, para evitar flicker).
    wrapper.classList.toggle('header-wrapper--fixed', scrolled);

    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        window.requestAnimationFrame(apply);
        ticking = true;
      }
    },
    { passive: true }
  );

  wrapper.addEventListener('mouseenter', () => {
    isHovering = true;
    apply();
  });
  wrapper.addEventListener('mouseleave', () => {
    isHovering = false;
    apply();
  });

  apply();
})();
